
import { Component, Vue } from "vue-property-decorator";
@Component
export default class ScrollTopButton extends Vue {
  private displayFab = false;

  mounted(): void {
    window.addEventListener("scroll", this.scrollManager);
  }
  beforeDestroy(): void {
    window.removeEventListener("scroll", this.scrollManager);
  }

  private scrollTop(): void {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  private scrollManager(): void {
    const amountScrolled =
      window.pageYOffset || document.documentElement.scrollTop;
    this.displayFab = amountScrolled > 500;
  }
}
